import _ from 'lodash';
import styles from '../../styles/chart-settings-interface.module.scss';
import { ChartSettingsElementType } from './chart-settings-v2-schema.types';
export const TabSkeleton = [
    {
        elementType: ChartSettingsElementType.TAB,
        addDividerBelow: true,
        properties: {
            layout: 'Horizontal',
            size: 'Medium',
            headerAlignment: 'left',
            enableOverflowControls: false,
            className: styles.axisTab,
            tabPanelClassName: styles.axisTabPanel,
        },
        children: [],
    },
];
export const TabItemSkeleton = {
    elementType: ChartSettingsElementType.TAB_ITEM,
    properties: {
        id: '',
        name: '',
        onTabItemClick: _.noop,
    },
    children: [],
};
//# sourceMappingURL=common-skeletons.js.map